export const OPERATION_AVAILABILITY_STATUS = {
  IDLE: 'IDLE',
  CHECKING: 'CHECKING',
  AVAILABLE: 'AVAILABLE',
  BLOCKED: 'BLOCKED',
  ERROR: 'ERROR',
};

export default OPERATION_AVAILABILITY_STATUS;
